import React, { Fragment, useEffect, useState, useRef } from "react";
import Carousel from "../components/Carousel";
import classnames from "classnames";
import GalleryModal from "../location/thumbnailGallery/GalleryModal";
import withThumbGalleryState from "../HOC/withThumbGalleryState";

let Location = props => {
    // Check if this is an event location based on category slug
    const isEventLocation = props.categorySlug === 'event-locations';
    const distanceInMiles = useRef(null);
    // useEffect(() => {
    //     return () => {
    //     }
    // }, [props])

    if (!!props.distance_in_miles) {
        distanceInMiles.current = props.distance_in_miles.toFixed(2);

        // Remove leading zero if the number is less than 1
        if (props.distance_in_miles < 1) {
            distanceInMiles.current = distanceInMiles.current.substring(1);
        }
    }

    let smallScreen = window.innerWidth <= 767 ? true : false;

    return (
        <Fragment>
            <li
                className={classnames(
                    props.className,
                    !!props.size ? `il-${props.size}-carousel-container` : 'il-sm-carousel-container',
                    'd-flex flex-wrap align-items-start'
                )}>
                {/* <div className="d-flex order-1 py-2"> */}
                {/* <div className="flex-grow-1"> */}
                <h5 className="h5 mb-0 w-100 mt-2 pr-md-5">
                    <a target="_blank" className="text-dark font-weight-light text-decoration-none" href={isEventLocation ? '/events/' + props.slug : '/' + props.slug}>
                        {props.title}
                    </a>
                </h5>

                {/* {!!props.city && ( */}
                <p className="location-city ellipse-overflow small mb-2 w-100">
                    {!!props.city ? props.city : <span>&nbsp;</span>}
                </p>
                {!!props.distance_in_miles && (
                    <p
                        className="text-center font-weight-bold position-absolute text-white"
                        style={{
                            textShadow: "0 1px 5px #000000",
                            zIndex: "100",
                            top: "5px",
                            right: "10px",
                            background: "rgba(0,0,0,0.5)",
                            padding: "2px 8px",
                            borderRadius: "3px",
                            fontSize: "0.8rem"
                        }}
                    >
                        {distanceInMiles.current} miles away
                    </p>
                )}
                {/* )} */}
                {/* </div> */}

                {!smallScreen && (
                    <button
                        className="il-thumb-gallery-modal-trigger btn pt-0 text-primary position-absolute"
                        data-toggle="modal"
                        data-target="#il-thumb-gallery-modal"
                        onClick={props.handleShow}
                    >
                        <svg className="align-top" width="25" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M319.8 204v8c0 6.6-5.4 12-12 12h-84v84c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12v-84h-84c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h84v-84c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12zm188.5 293L497 508.3c-4.7 4.7-12.3 4.7-17 0l-129-129c-2.3-2.3-3.5-5.3-3.5-8.5v-8.5C310.6 395.7 261.7 416 208 416 93.8 416 1.5 324.9 0 210.7-1.5 93.7 93.7-1.5 210.7 0 324.9 1.5 416 93.8 416 208c0 53.7-20.3 102.6-53.7 139.5h8.5c3.2 0 6.2 1.3 8.5 3.5l129 129c4.7 4.7 4.7 12.3 0 17zM384 208c0-97.3-78.7-176-176-176S32 110.7 32 208s78.7 176 176 176 176-78.7 176-176z"></path></svg>
                    </button>
                )}
                {/* </div> */}

                <Carousel
                    className="w-100"
                    locationSlug={props.slug}
                    mediaTags={props.categorySlug || null}
                    isActive={props.isActive}
                    onActiveCallback={props.onActiveCallback}
                    locationId={props.id}
                    title={props.title}
                    isEventLocation={isEventLocation}
                />
            </li>

            {!!props.show && (
                <GalleryModal
                    locationId={props.id}
                    title={props.title}
                    show={props.show}
                    handleClose={props.handleClose}
                />
            )}
        </Fragment >
    );
};

// don't rerender if no props or no state changed.
Location = React.memo(Location);

export default withThumbGalleryState(Location);
